// 刘
import  {get, post, del} from '../utils/request'


// 心理测评 查询
export const getData = (params)=>get('/api/userinfo',params)

// 心理测评 查看/下载 报告
export const getReport = (params)=>get('/api/userinfo',params)

// 心理测评 我要学习 列表数据
export const getList = (params)=>get('/api/userinfo',params)

// 心理测评 学习结果 证书数据
export const getCertificate = (params)=>get('/api/userinfo',params)

// 心理测评 学习结果 上传接口
export const upload = (params)=>get('/api/userinfo',params)

// 心理测评 健康教育
export const getHealthEducation = (params)=>get('/api/userinfo',params)

// 心理测评 教育理论
export const getEducationalTheory = (params)=>get('/api/userinfo',params)

// 心理测评 教学理论
export const getInstructionalTheory = (params)=>get('/api/userinfo',params)

// 心理测评 学科教学
export const getSubjectTeaching = (params)=>get('/api/userinfo',params)


// 尹

// 获取小鹅通access_token  直播课程
export const getToken=(params)=>get('/api/xiaoetech/token',params)

// 获取小鹅通直播列表数据
export const getLiveData=(data)=>post('/api/xiaoetech/xe.alive.list.get/1.0.0',data,false)

// 获取小鹅通大专栏
export const getBigSpecial = (data)=>post('/api/xiaoetech/xe.goods.list.get/4.0.0',data)

// 获取大专栏里面的专栏列表
export const getSpecial = (data)=>post('/api/xiaoetech/xe.goods.relation.get/4.0.0',data)

// 展示交流
// 获取展示交流列表
export const displayCommunicationList = (params) => get('/api/article/page/teacher',params)

// 获取展示交流详情信息
export const displayCommunicationDetail = (params) => get('/api/article/details/'+params,{})

// 保存查看状态
export const saveStatus = (data) => post('/api/article-browse-log/add/'+data,{})

// 查询教师选定课程数量
export const courseCount = (params) => get('https://yingde_api.ydassess.com/courses/teacher/locked/count',params)



// 课题研究
// 立项主题列表
export const projectThemeList = (params) =>get('/api/topic-research/page/teacher',params)

// 获取立项列表某条数据的详情
export const projectThemeDetail = (params) => get('/api/topic-research/details/teacher/project/'+params,params)

// 上传申请书
export const upFile = (data,isFile) => post('/api/common/fileUpload',data,isFile=true)

// 根据id更新申请书列表
export const upFileList = (url,data) => post(url,data)

// 立项管理发布咨询
export const sendMessage = (data) => post('/api/topic-research-comment/add/teacher',data)

// 研究成果列表
export const researchFindingsList = (params) => get('/api/topic-research/page/teacher',params)

// 研究成果详情
export const researchFindingsDetail = (params) => get('/api/topic-research/details/teacher/result/'+params,params)

// 研究课例
export const researchLessonList = (params) => get('/api/article/page/teacher',params)

// 选择该课程、取消选择该课程
export const changeClasses = (data) => post('https://yingde_api.ydassess.com/courses/teacher/lock/course',data)

// 获取教师端班级推荐课程
export const classesList = (params) => get('https://yingde_api.ydassess.com/courses/teacher/class/recommended',params)

// 获取学习结果证书
export const certificateList = (params) => get('/api/learn-result/page',params)

// 上传学习结果证书
export const uploadCertifivate = (params) => post('api/learn-result/add',params)

// 删除学习结果证书
export const delCertifivate = (url,params) => del(url,params)

// 上传文件接口
export const uploadFile = (params) => post('/api/common/fileUpload',params,true)




// WEBPACK FOOTER //
// ./src/api/teacher.js